import { useEffect, useState } from 'react';
import { DEFAULT_SUPPORT_EMAIL, getSupportEmail } from 'utils/supportInfo';

export const useSupportEmail = (): string => {
  const [supportEmail, setSupportEmail] = useState(DEFAULT_SUPPORT_EMAIL);

  useEffect(() => {
    getSupportEmail().then((email) => email && setSupportEmail(email));
  }, []);

  return supportEmail;
};
